<div class="layout">
  @if (showTherapistSidebar()) {
    <aside>
      <sana-tp-sidebar></sana-tp-sidebar>
    </aside>
  }

  <div
    class="main-wrapper"
    [ngClass]="{ 'ms-0': !showTherapistSidebar()}">

    @if (isTherapistLoaded()) {
      <sana-tp-subscription-banner></sana-tp-subscription-banner>
    }

    <main [ngClass]="{'login-wrapper': !isTherapistLoaded()}">
      <p-toast position="top-right"></p-toast>
      <router-outlet></router-outlet>
    </main>
  </div>

  @if (showTherapistMobileBar()) {
    <sana-tp-mobile-menu-bar></sana-tp-mobile-menu-bar>
  }
</div>
